import { Grid } from "@material-ui/core";
import HeaderItem from "./HeaderItem";
import useCustomState from "../../hooks/State";
import {
  Person,
  AccountTree,
  Check,
  Speed,
  AttachMoney,
  Category,
} from "@material-ui/icons";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const Header = () => {
  const statistics = useSelector((state) => state.statistics);

  const data = useCustomState([]);

  useEffect(() => {
    const d = [
      {
        icon: <Person />,
        name: "کابران",
        value: statistics.users,
        link: "/admin/users-management",
      },
      {
        icon: <AccountTree />,
        name: "پروژه ها",
        value: statistics.projects,
        link: "/admin/projects",
      },
      // {
      //   icon: <Check />,
      //   name: "کل رکوردهای مصرف",
      //   value: Math.round(statistics.totalRecords),
      //   link: "/admin",
      // },
      {
        icon: <Category />,
        name: "انواع کنتورها",
        value: statistics.counterTypes,
        link: "/admin/counter-types",
      },
      {
        icon: <Speed />,
        name: "کنتورها",
        value: statistics.counters,
        link: "/admin/counters",
      },
      {
        icon: <AttachMoney />,
        name: "کنتورهای فروش رفته",
        value: statistics.selledCounters,
        link: "/admin",
      },
    ];
    data.handleChange(d);
  }, [statistics]);

  return (
    <>
      <Grid
        style={{
          paddingRight: "4px",
          paddingLeft: "4px",
          paddingTop: "8px",
          paddingBottom: "8px",
          marginTop: "4px",
        }}
        container
        spacing={0}
      >
        {data.value.map((d, index) => {
          return <HeaderItem data={d} key={index} />;
        })}
      </Grid>
    </>
  );
};

export default Header;
